import webApi from "../../../WebApi/WebApi";

export const getFaqList = async (data) => {
    return await webApi.get('/faqs');
  }
